
import { observer } from 'mobx-react-lite'
import { HTMLAttributes, useEffect } from 'react'
import { Link, LinkProps } from 'react-router'
import { IconName, IconStyle } from '@fortawesome/fontawesome-common-types'
import classNames from 'classnames'

// evertel
import { Icon, Badge, Text, Row, Col } from '@evertel/web/ui'
import { useService } from '@evertel/di'
import { DepartmentController } from '@evertel/department'
import { SessionService } from '@evertel/session/SessionService'


interface DrawerNavRoomLinkProps extends LinkProps {
    label: string
    icon: IconName
    iconType?: IconStyle
    selected?: boolean
    unreadCount?: number
    hasUrgentUnreads?: boolean
    muted?: boolean
    departmentId?: number
    className?: string
}


const DrawerNavRoomLink: React.FC<DrawerNavRoomLinkProps> = observer(({
    label,
    icon,
    iconType = 'light',
    selected,
    unreadCount = 0,
    muted,
    hasUrgentUnreads,
    departmentId,
    to,
    className,
    ...otherProps
}) => {

    const departmentController = useService(DepartmentController, [departmentId])
    const sessionService = useService(SessionService, [])

    useEffect(() => {
        if (departmentId && departmentId !== sessionService.selectedDepartmentId) {
            departmentController.init(departmentId)
        }
    }, [departmentId])

    return (
        <Link
            to={to}
            className={classNames('drawer-item-link', className, {
                'hover-action': to,
                'active': selected,
                'muted': muted,
                'unread': unreadCount
            })}
            {...otherProps}
            data-drawer-nav="thread"
        >
            <Row valign="center" className="text-truncate" style={{flexBasis: '100%'}}>
                <Icon
                    name={icon || 'hashtag'}
                    color={(hasUrgentUnreads) ? 'danger' : undefined}
                    type={iconType}
                    className="me-3"
                />
                <Text
                    color={(hasUrgentUnreads) ? 'danger' : undefined}
                    className="text-truncate"
                >
                    {label}
                </Text>
            </Row>
            <Row valign="center">
                {(departmentId && departmentId !== sessionService.selectedDepartmentId) &&
                    <Badge
                        color="gray900"
                        className="ms-2">
                        {departmentController.shortName}
                    </Badge>
                }
                {(!!unreadCount) &&
                    <Badge
                        className="ms-2"
                        color={(muted) ? 'gray900' : (hasUrgentUnreads) ? 'danger' : 'warning'}>
                        {unreadCount}
                    </Badge>
                }
            </Row>
        </Link>
    )
})

export { DrawerNavRoomLink }
